import Link from 'next/link';
import research from '@/content/research/metadata.generated.json';

export default function ResearchArticleCard() {
  if (!research.published) return null;
  return <aside className="mx-auto my-10 max-w-5xl rounded-2xl border border-indigo-200 bg-indigo-50 p-6 text-slate-900 sm:p-8">
    <p className="mb-2 text-xs font-semibold uppercase tracking-widest text-indigo-700">Research &amp; discussion</p>
    <h2 className="mb-3 text-2xl font-semibold">Can an AI tutor replace a human one?</h2>
    <p className="mb-4 leading-relaxed">Explore the legal challenges for AI learning apps in our UK-focused discussion paper. Examine the sources and contribute a reasoned challenge.</p>
    <Link href={research.path} className="font-semibold text-indigo-800 underline underline-offset-4">Read the paper and join the discussion</Link>
  </aside>;
}
